import { Checkbox } from 'antd'
import React from 'react'

const BoolCell = ({ value }) => value && <Checkbox checked={value} />
export default BoolCell
